<div class="complience-card">
  <div class="legend-container">
    <div class="sla-month">
      <label>SLA</label>
      <span>vs last month</span>
    </div>
    <div class="sla-percent">
      <div class="growth-percent">
        <motif-icon
          [src]="'/assets/icons/navigation/ic_arrow_downward_24px.svg'"
        ></motif-icon
        >{{clientDetails.slaComplianceCurrent}}%
      </div>
      <span>{{clientDetails.slaComplianceLast}}%</span>
    </div>
  </div>
  <div class="chart">
    <div class="content">
      <label>Overall SLA</label>
      <strong>{{clientDetails.slaComplianceCurrent}}%</strong>
    </div>
    <app-donut-chart
      *ngIf="clientDetails"
      [donutChartData]="slaComplianceChartData"
      [name]="'sla'"
      [width]="chartWidth"
      [height]="chartHeight"
    ></app-donut-chart>
  </div>
</div>
